module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"retry":"Retry"},"de":{"retry":"Wiederholen"}}')
  delete Component.options._Ctor
}
